import React from 'react'

export const AdFacebookEditContext = React.createContext()

export const AdFacebookEditContextProvider = ({ children, campaignObjective = '' }) => {
  return <AdFacebookEditContext.Provider value={{ campaignObjective }}>{children}</AdFacebookEditContext.Provider>
}
